import React from "react";
import webui from "@tinqin/tinqin-web-ui";
import { xssFilter } from "../../../common/utils/xssFilter";
import { IComponentProps, IExtractedProps } from "Common/utils/commonTypes";

export const SolutionBox: React.FC<IComponentProps> = props => {
    const data: Record<string, any> = props.data ? props.data.properties || {} : null;
    if (!data) {
        return null;
    }
    const dataProps: IExtractedProps = webui.getUtils().extractComponentProps(props, {
        additionalProps: ["text", "title", "image", "color", "alt", "anchorId"]
    });
    return (
        <div className="tq-flex-container" id={dataProps.anchorId ? dataProps.anchorId : null}>
            <div
                className={`un-left-border-box-${dataProps.color}
                tq-flex-item un-left-border-box un-left-border-box-wide`}
            >
                <img src={dataProps.image} alt={dataProps.alt} />
                <div className="tq-title">
                    <span
                        className="tq-text-node"
                        dangerouslySetInnerHTML={{
                            __html: xssFilter.process(dataProps.title)
                        }}
                        data-hyperlinks-container={true}
                    />
                </div>
                <div
                    className="un-left-border-box-content"
                    dangerouslySetInnerHTML={{
                        __html: xssFilter.process(dataProps.text)
                    }}
                    data-hyperlinks-container={true}
                ></div>
            </div>
        </div>
    );
};

export default webui.connectComponent()(SolutionBox);
